export default __webpack_public_path__ + "static/media/premium_male@2x.79dff413.png";